<template>
    <van-popup v-model="showAlert" class="pay_box">
        <div class="cusSer_main">
            <img :src="require('@/common/images/activeTools/pay.png')">
            <p class="text">您当前有待支付的订单，<br>请尽快完成支付！</p>
            <div class="tips">
                <p @click="hideDialog">再想想</p>
                <p @click="toPayEvent">查看订单</p>
            </div>
        </div>
        <div class="closeBox">
            <img class="close" @click="hideDialog" :src="require('@/common/images/activeTools/close.png')" alt="">
        </div>
    </van-popup>
</template>

<script>
export default {
    name: 'ToPay',
    data() {
        return {
            showAlert: false,
            url: '',
            eventid: ''
        }
    },
    methods: {
        showDialog(url, id) {
            console.log(url)
            this.url = url
            this.eventid = id
            this.showAlert = true
        },
        hideDialog() {
            this.showAlert = false
        },
        toPayEvent() {
            // window.location.href = this.url
            this.$router.push({name: 'MOrderList'})
        }
    }
}
</script>

<style lang="scss">
.pay_box {
    text-align: center;
    background: transparent;
    .cusSer_main {
        width: 5.2rem;
        height: 4.74rem;
        padding: .45rem 0;
        background: #fff;
        border-radius: .15rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        img {
            width: 2.3rem;
            height: 1.95rem;
            display: inline-block;
        }
        .text {
            font-size: .32rem;
            color: #333;
            line-height: .46rem;
        }
        .tips {
            font-size: .28rem;
            color: #333;
            margin-top: .2rem;
            display: flex;
            p {
                width: 1.8rem;
                height: .6rem;
                line-height: .64rem;
                text-align: center;
                border-radius: .3rem;
            }
            p:first-child {
                border: .02rem solid #0ABF53;
                color: #0ABF53;
                margin-right: .5rem;
            }
            p:last-child {
                color: #fff;
                background: linear-gradient(360deg,rgba(10,191,83,1) 0%,rgba(71,236,201,1) 100%);
            }
        }
    }
    .closeBox {
        width: 0.6rem;
        height: 0.6rem;
        margin: 0.4rem auto;
        .close {
            width: 0.6rem;
            height: 0.6rem;
        }
    }
}
</style>


